import React from 'react';
import { useState } from 'react';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { RegionalActHeaderNav } from './RegionalActHeaderNav';
import { InfoFooter } from '../../InfoFooter';
import classes from '../Manage Assets Subcategory/AssetsSubcategory.module.css'
import favicon from '../../Images/faviconn.png';
import CurrencyInput from 'react-currency-input-field';
import Select from 'react-select';


function AssetsRegionalDisposalUi({
  show,
  isAdmin,
  show1,
  handleShow,
  handleShow1,
  handleClose,
  handleClose1,
  createUser,
  createAssetsDisposal,
  editUser,
  isLoading,
  loading,
  searchTerm,
  setSearchTerm,
  entriesPerPage,
  setEntriesPerPage,
  currentPage,
  setCurrentPage,
  totalEntries,
  totalPages,
  startIndexx,
  endIndexx,
  displayedData,
  handlePrevPage,
  handleNextPage,
  handleEyeClick,
  handleTrashClick,
  fullName,
  setFullName,
  address,
  setAddress,
  office_address,
  setOfficeAddress,
  phone,
  setPhone,
  email,
  setEmail,
  fullName1,
  setFullName1,
  phone1,
  setPhone1,
  email1,
  setEmail1,
  tableData,
  tableData1,
  formatDate,
  selectedContinent,
  description,
  setDescription,
  setSelectedContinent,
  handleContinentChange,

  // createAssetsDisposer,
  selectedAssets,
  selectedDisposedDate,
  selectedAmountDisposed,
  setSelectedAssets,
  setSelectedDisposedDate,
  setSelectedAmountDisposed,
  // selectedCreatedBy,
  // selectedDisposer,

  handleAssetsChange,
  handleAmountChange,
  // handleDisposerDateChange,
  // handleCreatedByDateChange,
  // handleDisposerChange

}) {

  const [balance, setBalance] = useState("");

  const handleValueChange = (value, name, values) => {
    setSelectedAmountDisposed(value); // Update the balance state
    // console.log(value, name, values);
  };

  return (
    <div style={{ marginTop: '8rem' }}>
      <div className="wrapper">
        {/* <!-- Sidebar  --> */}


        {/* <!-- Page Content  --> */}
        <div className="content-wrapper">
          <div className="main-content">

            <RegionalActHeaderNav/>
            <div className='newBody'>
              <div className='newWidth'>

                {/* <!--Content Header (Page header)--> */}
                <div className="content-header row align-items-center m-0">
{/*                
                  <nav aria-label="breadcrumb" className="col-sm-4 order-sm-last mb-3 mb-sm-0 p-0 ">
                    <div
                      style={{
                        marginTop: 20,
                        marginBottom: 20,
                        justifyContent: "flex-end",
                        display: "flex",
                        marginLeft: "auto",
                      }}
                    >
                      <Button variant="success" onClick={handleShow} >
                        Add New Disposal
                      </Button>
                    </div>

                  </nav> */}
             
                  <div className="col-sm-8 header-title p-0">
                    <div className="media">
                      <div className="header-icon text-success mr-3"><i className=""><img src={favicon} className={classes.favshi} alt="favicon" /></i></div>
                      <div className="media-body">
                        <h1 className="font-weight-bold">Manage Disposal</h1>
                        <small>Dispose your assets...</small>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <!--/.Content Header (Page header)--> */}
                <div className="body-content">
                  <div className="row">

                    <div className="col-lg-12 col-xl-6">
                      <div className="row">

                        <div className="col-md-6 col-lg-6">

                          {/* <!--Feedback--> */}

                        </div>
                        <div className="col-md-6 col-lg-6">

                          {/* <!--Balance indicator--> */}

                        </div>
                        <div className="col-md-6 col-lg-6">

                          {/* <!--Time on site indicator--> */}

                        </div>
                        <div className="col-md-6 col-lg-6">

                          {/* <!--Top Referrals--> */}

                        </div>
                        <div className="col-md-6 col-lg-6">

                          {/* <!--Sessions by device--> */}

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-lg-12 col-xl-3 mb-4">
                      <div className="card">


                      </div>
                    </div>

                    <Modal show={show} onHide={handleClose} animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title>Create Dispose Asset</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">

                            <Form.Label>Assets</Form.Label>
                            {/* <Form.Control
                            type="text"
                            placeholder="Enter Asset"
                            
                            value={selectedAssets}
                            onChange={(e)=> setSelectedAssets (e.target.value)}
                          /> */}

                            <Form.Select
                              className="form-control"
                              type='text'
                              value={selectedAssets}
                              onChange={handleAssetsChange}
                            >
                              <option value="" disabled>Select Assets</option>
                              {tableData1.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.description}
                                </option>
                              ))}
                            </Form.Select>

                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Date of disposal</Form.Label>
                            <Form.Control
                              type="date"
                              placeholder="Select date"

                              value={selectedDisposedDate}
                              onChange={(e) => setSelectedDisposedDate(e.target.value)}
                            />

                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Amount disposed</Form.Label>
                            <CurrencyInput
                              id="exampleForm.ControlInput1"
                              name="Balance"
                              placeholder="Enter amount disposed"
                              decimalsLimit={2}
                              value={selectedAmountDisposed} // Set the value to the balance state
                              onValueChange={handleValueChange}
                              style={{

                                minWidth: "100%",
                                height: "calc(1.8em + .75rem + 2px)",
                                border: '1px solid #e4e5e7',
                                borderRadius: 5,
                                overflow: 'hidden',
                                zIndex: 999,
                                fontSize: 14,
                                padding: ".375rem .75rem",
                                textAlign: "right"
                              }}
                            />

                          </Form.Group>
                        </Form>
                      </Modal.Body>



                      <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>
                          Go back
                        </Button>
                        <Button variant="success" onClick={createAssetsDisposal}>
                          {loading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Creating assets disposal, Please wait...</span>
                            </>
                          ) : (
                            "Create Assets Disposal"
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>

                    <div className="col-lg-12">
                      <div className="card">
                        {/* <div className="card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="fs-17 font-weight-600 mb-0">Users List</h6>
                            </div>

                          </div>
                        </div> */}
                        <div className="card-body">
                          <div className="table-resposive">
                            <div className="d-flex justify-content-between align-items-center" style={{ padding: '20px 0 0 0', marginBottom: 20 }}>
                              <div className={classes.greenbtn} style={{ display: 'flex', }}>
                                <div>
                                  <button>Copy</button>
                                  <button>Excel</button>
                                  <button>PDF</button>
                                  <button className={classes.diffbtn}>Column visibility</button>
                                </div>
                                <div>
                                  <label className="d-flex justify-content-start align-items-center">
                                    Show
                                    <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" className="custom-select custom-select-sm form-control form-control-sm" value={entriesPerPage}
                                      onChange={(e) => {
                                        setEntriesPerPage(parseInt(e.target.value));
                                        setCurrentPage(1);
                                      }}>
                                      <option value={10}>10</option>
                                      <option value={25}>25</option>
                                      <option value={50}>50</option>
                                      <option value={100}>100</option>
                                    </select>
                                    entries
                                  </label>
                                </div>
                              </div>
                              <div className="text-right modal-effect ">
                                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div className="mr-2">Search:</div>
                                    <input
                                      type="search"
                                      value={searchTerm}
                                      className="form-control form-control-sm"
                                      placeholder=""
                                      aria-controls="DataTables_Table_0"
                                      onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        // setCurrentPage(1);
                                      }}
                                    />
                                  </div>

                                </div>
                              </div>
                            </div>


                            {isLoading ? (
                              <p>Fetching disposal...</p>
                            ) : (
                              <div className="table-responsive">
                                <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">

                                  <thead style={{ whiteSpace: 'nowrap' }}>
                                    <tr>
                                      <th>ID</th>
                                      <th>Assets</th>
                                      <th>Date Disposed</th>
                                      <th>Amount Disposed</th>
                                      <th>Proceed on sale</th>
                                      <th>Profit/Loss</th>
                                      <th>Accumulated Depreciation</th>
                                      {/* <th>Date Created</th> */}
                                      {/* <th>Date Updated</th> */}
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody style={{ whiteSpace: 'nowrap' }}>
                                    {displayedData.map((item, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.description}</td>
                                        <td>{item.date_disposed}</td>
                                        <td style={{ textAlign: "right" }}>{parseFloat(item.amount_disposed).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}</td>
                                        <td style={{ textAlign: "right" }}>{parseFloat(item.asset?.proceed_on_sale === null ? "0.00" : item.asset?.proceed_on_sale).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}</td>
                                        <td></td>
                                        <td></td>
                                        {/* <td>{formatDate(item.created_at)}</td> */}
                                        {/* <td>{formatDate(item.updated_at)}</td> */}
                                        <td>
                                          <div onClick={() => handleEyeClick(item.id)} className="btn btn-success-soft btn-sm mr-1">
                                            <i className="far fa-edit"></i>
                                          </div>
                                          <div onClick={() => handleTrashClick(item.id)} className="btn btn-danger-soft btn-sm">
                                            <i className="far fa-trash-alt"></i>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            <div className={classes.endded}>
                              <p>
                                Showing {startIndexx} to {endIndexx} of {totalEntries} entries
                              </p>
                              <div style={{ display: 'flex' }}>
                                <button
                                  style={{ border: 'none', backgroundColor: 'gainsboro', borderRadius: 3, height: '2.5rem', width: '100px', fontWeight: 500, fontSize: 14, padding: '0.5rem', fontFamily: 'nunito', color: '#000', marginRight: 10, cursor: "pointer" }}
                                  onClick={handlePrevPage}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>
                                {[...Array(totalPages)].map((_, page) => {
                                  // Show only 5 pages or less if available
                                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                                    return (
                                      <button
                                        key={page + 1}
                                        style={{
                                          marginLeft: '0.4rem',
                                          marginRight: '0.4rem',
                                          fontSize: '14px',
                                          fontFamily: 'nunito',
                                          fontWeight: 400,
                                          color: page + 1 === currentPage ? '#ffffff' : '#000',
                                          backgroundColor: page + 1 === currentPage ? '#28a745' : 'gainsboro',
                                          height: '2.5rem',
                                          borderRadius: '89px',
                                          padding: '0.5rem',
                                          border: 'none',
                                          width: '40px',
                                          cursor: "pointer"
                                        }}
                                        onClick={() => setCurrentPage(page + 1)}
                                      >
                                        {page + 1}
                                      </button>
                                    );
                                  }
                                  return null;
                                })}
                                <button
                                  style={{ cursor: "pointer", border: 'none', backgroundColor: 'gainsboro', borderRadius: 3, height: '2.5rem', width: '100px', fontWeight: 500, fontSize: 14, padding: '0.5rem', fontFamily: 'nunito', color: '#000', marginLeft: 10 }}
                                  onClick={handleNextPage}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </div>
                            </div>

                            <Modal show={show1} onHide={handleClose1} animation={false}>
                              <Modal.Header closeButton>
                                <Modal.Title>Update Asset Disposal</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">

                            <Form.Label>Assets</Form.Label>
                            {/* <Form.Control
                            type="text"
                            placeholder="Enter Asset"
                            
                            value={selectedAssets}
                            onChange={(e)=> setSelectedAssets (e.target.value)}
                          /> */}

                            <Form.Select
                              className="form-control"
                              type='text'
                              value={selectedAssets}
                              onChange={handleAssetsChange}
                            >
                              <option value="" disabled>Select Assets</option>
                              {tableData1.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.description}
                                </option>
                              ))}
                            </Form.Select>

                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Date of disposal</Form.Label>
                            <Form.Control
                              type="date"
                              placeholder="Select date"

                              value={selectedDisposedDate}
                              onChange={(e) => setSelectedDisposedDate(e.target.value)}
                            />

                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Amount disposed</Form.Label>
                            <CurrencyInput
                              id="exampleForm.ControlInput1"
                              name="Balance"
                              placeholder="Enter amount disposed"
                              decimalsLimit={2}
                              value={selectedAmountDisposed} // Set the value to the balance state
                              onValueChange={handleValueChange}
                              style={{

                                minWidth: "100%",
                                height: "calc(1.8em + .75rem + 2px)",
                                border: '1px solid #e4e5e7',
                                borderRadius: 5,
                                overflow: 'hidden',
                                zIndex: 999,
                                fontSize: 14,
                                padding: ".375rem .75rem",
                                textAlign: "right"
                              }}
                            />

                          </Form.Group>
                        </Form>
                      </Modal.Body>






                              <Modal.Footer>
                                <Button variant="danger" onClick={handleClose1}>
                                  Go back
                                </Button>
                                <Button variant="success"  >                             {loading ? <Spinner id="loader" animation="border" variant="warning" /> : 'Save Changes'}
                                </Button>
                              </Modal.Footer>
                            </Modal>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--/.body content--> */}
              </div>
              {/* <!--/.main content--> */}
            </div>
          </div>
          <InfoFooter />
          {/* <!--/.footer content--> */}
          <div className="overlay"></div>
        </div>
        {/* <!--/.wrapper--> */}


      </div>
    </div>
  );
}

export default AssetsRegionalDisposalUi;
